import React, { useState, useEffect } from 'react';

const Informasi = () => {
  const [informasi, setInformasi] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulasi fetch data dari API
    setTimeout(() => {
      setInformasi([
        {
          id: 1,
          judul: 'BUMDES Desa Makmur Raih Penghargaan',
          konten: 'BUMDES Desa Makmur mendapatkan penghargaan sebagai BUMDES terbaik se-kabupaten tahun 2024. Penghargaan ini diberikan atas kinerja dan kontribusi BUMDES dalam memajukan perekonomian desa...',
          tanggal: '2024-01-15',
          penulis: 'Admin BUMDES',
          kategori: 'Prestasi',
          dibaca: 124,
          status: 'published'
        },
        {
          id: 2,
          judul: 'Pelatihan Pengolahan Hasil Pertanian',
          konten: 'Akan diadakan pelatihan pengolahan hasil pertanian untuk meningkatkan nilai jual produk. Pelatihan ini terbuka untuk semua warga desa yang berminat...',
          tanggal: '2024-01-10',
          penulis: 'Tim Pengembangan',
          kategori: 'Kegiatan',
          dibaca: 89,
          status: 'published'
        },
        {
          id: 3,
          judul: 'Laporan Keuangan Triwulan IV 2023',
          konten: 'Laporan keuangan BUMDES untuk triwulan IV tahun 2023 telah tersedia untuk diakses. Laporan ini mencakup semua transaksi dan perkembangan keuangan BUMDES...',
          tanggal: '2024-01-05',
          penulis: 'Bendahara',
          kategori: 'Laporan',
          dibaca: 156,
          status: 'draft'
        }
      ]);
      setLoading(false);
    }, 1000);
  }, []);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const getStatusColor = (status) => {
    return status === 'published' 
      ? 'bg-green-100 text-green-800'
      : 'bg-yellow-100 text-yellow-800';
  };

  const getCategoryColor = (kategori) => {
    switch (kategori) {
      case 'Prestasi':
        return 'bg-green-100 text-green-800';
      case 'Kegiatan':
        return 'bg-blue-100 text-blue-800';
      case 'Laporan':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Manajemen Informasi</h1>
          <p className="text-gray-600">Kelola berita dan pengumuman BUMDES</p>
        </div>
        <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center">
          <span className="mr-2">+</span> Buat Informasi
        </button>
      </div>

      {/* Informasi List */}
      <div className="space-y-6">
        {informasi.map((item) => (
          <article key={item.id} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow">
            <div className="p-6">
              <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-4">
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-2 mb-3">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${getCategoryColor(item.kategori)}`}>
                      {item.kategori}
                    </span>
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(item.status)}`}>
                      {item.status === 'published' ? '📢 Published' : '📝 Draft'}
                    </span>
                    <span className="text-sm text-gray-500">{formatDate(item.tanggal)}</span>
                  </div>
                  <h2 className="text-xl font-bold text-gray-900 mb-3">{item.judul}</h2>
                </div>
                <div className="flex items-center space-x-4 mt-3 lg:mt-0">
                  <div className="flex items-center text-sm text-gray-500 bg-gray-50 px-3 py-1 rounded-lg">
                    <span className="mr-1">👁️</span>
                    {item.dibaca} dibaca
                  </div>
                </div>
              </div>

              <p className="text-gray-600 mb-6 leading-relaxed line-clamp-3">{item.konten}</p>

              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between pt-4 border-t border-gray-100">
                <div className="flex items-center text-sm text-gray-500 mb-3 lg:mb-0">
                  <span className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-xs font-semibold text-white mr-3">
                    {item.penulis.charAt(0)}
                  </span>
                  Ditulis oleh <strong className="ml-1 text-gray-700">{item.penulis}</strong>
                </div>
                
                <div className="flex space-x-3">
                  <button className="text-blue-600 hover:text-blue-800 font-medium text-sm bg-blue-50 hover:bg-blue-100 px-4 py-2 rounded-lg transition-colors">
                    Edit
                  </button>
                  <button className="text-green-600 hover:text-green-800 font-medium text-sm bg-green-50 hover:bg-green-100 px-4 py-2 rounded-lg transition-colors">
                    {item.status === 'draft' ? 'Publish' : 'Unpublish'}
                  </button>
                  <button className="text-red-600 hover:text-red-800 font-medium text-sm bg-red-50 hover:bg-red-100 px-4 py-2 rounded-lg transition-colors">
                    Hapus
                  </button>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>

      {/* Empty State */}
      {informasi.length === 0 && (
        <div className="text-center py-12 bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="text-6xl mb-4">📰</div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">Belum ada informasi</h3>
          <p className="text-gray-600 mb-6">Mulai buat informasi pertama untuk dibagikan ke warga.</p>
          <button className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-medium transition-colors">
            + Buat Informasi Pertama
          </button>
        </div>
      )}
    </div>
  );
};

export default Informasi;